import type { ChatMessage } from "@/lib/types";
import { cn } from "@/lib/utils";
import { AssistantContent } from "@/components/chat/assistant-content";
import { ToolsUsedPanel } from "@/components/chat/tools-used-panel";

type MessageBubbleProps = {
  message: ChatMessage;
};

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === "user";
  const isError =
    message.role === "assistant" && message.content.startsWith("Error:");

  return (
    <div className={cn("flex", isUser ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[85%] rounded-2xl px-4 py-3 sm:max-w-[75%]",
          isUser
            ? "bg-saffron-600 text-white"
            : isError
              ? "border border-red-200 bg-red-50 text-red-900"
              : "border bg-card text-card-foreground shadow-sm"
        )}
      >
        {isUser ? (
          <p className="whitespace-pre-wrap text-sm leading-relaxed">
            {message.content}
          </p>
        ) : (
          <>
            <AssistantContent content={message.content} />
            {message.tools_used && message.tools_used.length > 0 && (
              <ToolsUsedPanel tools={message.tools_used} />
            )}
          </>
        )}
      </div>
    </div>
  );
}
